var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPWAInstallable)?_c('span',[_vm._t("default",function(){return [_c('b-button',{attrs:{"variant":"outline-secondary"},on:{"click":_vm.installPWA}},[_c('b-icon',{staticClass:"mr-2",attrs:{"icon":"download"}}),_vm._v("\n      Instaluj aplikację\n    ")],1)]},{"installPwa":_vm.installPWA,"isPwaInstallable":_vm.isPWAInstallable})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }